import type React from 'react'
import { ContainerDivider } from '..'

type IContainerDividerFilterProps = {}

const ContainerDividerFilter: React.FC<
  IContainerDividerFilterProps
> = props => {
  return <ContainerDivider type={{ name: 'vertical', height: 25 }} />
}

export default ContainerDividerFilter
